export const manufacturingData = {
  banner: {
    image: "/images/manu-img.jpg",
    alt: "Manufacturing",
  },
  breadcrumb: [
    { label: "HOME", href: "/" },
    { label: "MANUFACTURING", href: "/manufacturing" },
  ],
  pageTitle: "Manufacturing",
  whereWeAre: {
    description:
      "Our Manufacturing  unit is located at Plot No. D-26/1, Kurkumbh MIDC, Tal – Daund, Dist – Pune,  State – Maharashtra, India  413802.",
  },
  facilities: {
    items: [
      "Multipurpose manufacturing plant.",
      "Installed Reaction capacity of 81.53 KL with 22 reactors - 6 Stainless Steel reactors, 16 Glass Lined reactors, One Cryogenic reactor, ranging from 630 L to 6,300 L.",
      "Reaction Temperature ranging from -75°C to +150°C.",
      "High vacuum distillation.",
      "Utilities such as Thermic fluid heater, Steam boiler, Chilling plant, brine circulation and Liquid Nitrogen based cryogenic facility.",
    ],
    temperatureUsesSuperscript: true,
  },
  warehousing: {
    items: [
      "Separate storage facility for Solid and Liquid Raw Materials",
      "Separate area for Packing Material storage",
      "Solid Raw Material storage capacity of 150 MT",
      "Liquid Raw Material storage capacity of 72 KL",
      "Separate dispensing area for Solid and Liquid Raw Material",
      "Separate Quarantine area, sampling room, washing area",
    ],
  },
  images: {
    manuImg: "/images/manu-img.jpg",
    warehouseImg: "/images/warehouse-img.jpg",
    mipl4Img: "/images/MIPL 4.jpg",
  },
};
